<template>
  <v-container fluid style="min-height:600px;">
    <v-layout justify-center>
      <v-flex v-if="school">
        <Panel title="Confirmation">
          <p class="text-xs-center mt-3 headline">You have been invited to join</p>
          <p class="text-xs-center display-1" style="font-weight:bold;">{{school}}</p>
          
          <div class="text-xs-center mt-3 pa-3">
            <v-btn 
              color="secondary"
              large
              v-on:click="joinPressed"
            >
              Join School
            </v-btn>
          </div>
        </Panel>
      </v-flex>
      <v-flex v-else>
        <v-progress-linear class="secondary" indeterminate></v-progress-linear>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Panel from '@/components/Panel'
import RedeemService from '@/services/RedeemService'

export default {
  data: function () {
    return {
      school: null,
      loggedIn: this.$store.getters.loggedIn,
      error: null
    }
  },
  components: {
    Panel
  },
  mounted: async function () {
    const code = this.$route.params.code;

    if (!this.$store.getters.loggedIn) {
      // must be logged in to use this view
      // attach the invitation to the state and as the user to log in
      this.$store.dispatch('setLoginRedirect', {
        reason: 'An account for this email address was found. Please log in to continue.',
        path: this.$router.currentRoute.path
      })
      this.$router.push({
        name: 'login'
      })
      return;
    }

    try {
      const result = await RedeemService.get(code)

      this.school = result.data.school
    } catch (err) {
      this.error = err.response.data.error;
    }
  },
  methods: {
    async joinPressed () {
      const code = this.$route.params.code;
      try {
        const response = await RedeemService.processJoinCodeForUser(code)

        this.$store.dispatch('setToken', response.data.token);
        this.$store.dispatch('setUser', response.data.user);

        this.$router.push({
          path: '/'
        })
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped>

</style>
